<template>

    <section class="container">

        <header class="container__header">

            <h1>Opret bestilling</h1>

        </header>

        <section class="container__body container__body--sm">

            <section class="col-12 margin-b-50">

                <router-link :to="{name:'make-order-choice'}">Tilbage</router-link>

            </section>

            <section class="col-10 margin-b-75">

                <label>Produktnavn</label>

                <input class="col-12" type="text" name="name" autocomplete="off" placeholder="Hvad er produktnavn?" minlength="3" maxlength="120" required v-model="title">

            </section>

            <section class="col-10 margin-b-75">

                <label>Pris pr. kuvert</label>

                <section class="unit">

                    <input class="col-12" type="text" name="price" placeholder="Hvad er prisen pr. kuvert?" required v-model="priceFormatted">

                    <span>DKK</span>

                </section>

            </section>

            <section class="col-10 margin-b-75">

                <label>Antal kuverter</label>

                <section class="unit">

                    <input class="col-12" type="text" name="quantity" placeholder="Hvad er antal kuverter?" required v-model="quantity">

                    <span>STK</span>

                </section>

            </section>

            <section class="col-10 margin-b-50">

                <a href="#" class="btn btn--sm btn--secondary secondary--grey" @click.prevent="showCreateModal = true">Opret gruppe</a>

            </section>

            <section class="col-10">

                <draggable v-model="selections">

                    <transition-group name="fade">

                        <section class="data-list margin-b-100" v-for="selection in selections" :key="selection.title">

                            <header class="col-12 margin-b-50 settings">

                                <h1 v-text="selection.title"></h1>

                                <ws-dropdown>

                                    <template slot="thumb">	<i class="fas fa-cog icon--sm dark-grey"></i></template>

                                    <template slot="content">

                                        <ul>
                                            <li><a href="#" @click.prevent="showEditSelectionModal(selection)"><i class="fas fa-pencil-alt"></i> Rediger</a></li>
                                            <li><a href="#" @click.prevent="showDeleteSelectionModal(selection)"><i class="fas fa-trash-alt"></i> Slet</a></li>
                                        </ul>

                                    </template>

                                </ws-dropdown>

                            </header>

                            <section class="item" v-for="option in selection.options">

                                <section class="icon">

                                    <i class="icon--lg fas fa-shopping-bag"></i>

                                </section>

                                <section class="content">

                                    <h1 v-text="option.option.title"></h1>

                                </section>

                                <section class="link">
                                    <a href="#" @click.prevent="increaseQuantityForOption(selection, option)">+</a>
                                    <input type="number" readonly :value="option.quantity">
                                    <a href="#" @click.prevent="decreaseQuantityForOption(selection, option)">-</a>
                                </section>

                                <section class="link">

                                    <a href="product-stats" @click.prevent="removeOption(selection, option)">Fjern</a>

                                </section>

                            </section>

                            <section class="item--add padding-tb-50" @click.prevent="openAddOptionModal(selection)">

                                <section class="icon">

                                    <i class="fas fa-plus-circle"></i>

                                </section>

                                <section class="content">

                                    <h2>Tilføj tilvalg</h2>

                                </section>

                            </section>

                        </section>

                        <section class="data-list" v-if="selections.length == 0" key="notfound">

                            <h4>Ingen grupper fundet</h4>

                        </section>

                    </transition-group>

                </draggable>

            </section>

            <section class="col-12 margin-t-75">

                <button class="btn btn--md btn--primary primary--copper" @click.prevent="storeDetailsAndContinue" :disabled="isSaving || !validateProduct">

                    <span v-if="isSaving"><i class="spinner--light"></i> Gemmer</span>

                    <span v-else>Gem og fortsæt</span>

                </button>

            </section>

            <ws-modal v-model="showOptionListModal">

                <section class="modal-wrap--search">

                    <section class="modal--sm">

                        <span class="close" @click.prevent="showOptionListModal = false"><i class="fas fa-times"></i></span>

                        <options-list @selected="addOption" :selection-options="currentSelectionOptionsById" v-if="currentSelection"></options-list>

                    </section>

                </section>

            </ws-modal>

            <ws-modal v-model="showCreateModal">

                <section class="modal-wrap">

                    <section class="modal--sm">

                        <h1 class="margin-b-100">Opret gruppe</h1>

                        <span class="close" @click.prevent="showCreateModal = false"><i class="fas fa-times"></i></span>

                        <selection-form @completed="selectionCreated"></selection-form>

                    </section>

                </section>

            </ws-modal>

            <ws-modal v-model="showEditModal">

                <section class="modal-wrap">

                    <section class="modal--sm">

                        <h1 class="margin-b-100">Rediger gruppe</h1>

                        <span class="close" @click.prevent="showEditModal = false"><i class="fas fa-times"></i></span>

                        <selection-form @completed="selectionUpdated" :selection="currentSelection"></selection-form>

                    </section>

                </section>

            </ws-modal>

            <ws-modal v-model="showDeleteModal">

                <section class="modal-wrap">

                    <section class="modal--sm center" v-if="currentSelection">

                        <span class="close" @click.prevent="showDeleteModal = false"><i class="fas fa-times"></i></span>

                        <i class="fas fa-trash-alt icon--lg margin-b-25"></i>

                        <h1>Slet gruppe?</h1>

                        <h2>Er du sikker på du vil slette {{currentSelection.title}}?</h2>

                        <h3>Du kan ikke fortryde denne handling!</h3>

                        <section class="col-12 margin-t-25">

                            <a class="btn btn--sm btn--primary primary--copper" href="#" @click.prevent="deleteSelection">Ja tak</a>

                            <a href="#" @click.prevent="showDeleteModal = false">Nej tak!</a>

                        </section>

                    </section>

                </section>

            </ws-modal>

        </section>

    </section>

</template>

<script>
import {mapGetters} from 'vuex';
import SelectionForm from './partials/selectionForm.vue';
import OptionsList from './partials/optionsList.vue';

export default {
    name: "product",
    data(){
        return {
            title:'',
            quantity: 1,
            price_per_unit: 0,
            selections:[],
            showOptionListModal:false,
            showCreateModal:false,
            showEditModal:false,
            showDeleteModal:false,
            currentSelection:null,
            isSaving:false,
        }
    },
    components:{
        SelectionForm,
        OptionsList
    },
    computed:{
        priceFormatted:{
            get(){
                return (this.price_per_unit !== '') ? this.stripeAmount(this.price_per_unit).amountForEditing:'';
            },
            set(value){
                this.price_per_unit = this.amountToStripe(value);
            }
        },
        validateName(){
            return this.title !== '' && String(this.title).length > 0;
        },
        validatePricePerUnit(){
            return this.price_per_unit > 0;
        },
        validateQuantity(){
            return this.quantity > 0;
        },
        validateSelectionsAndOptions(){
            let isValid = true;

            if(this.selections.length === 0){
                isValid = false;
            }

            this.selections.forEach(item => {
                if(!item.options || item.options.length <= 0){
                    isValid = false;
                }

                item.options.forEach(option=>{
                    if(option.quantity <= 0){
                        isValid = false;
                    }
                });
            });
            return isValid;
        },
        validateProduct(){
            return this.validateName && this.validatePricePerUnit && this.validateQuantity && this.validateSelectionsAndOptions;
        },
        currentSelectionOptionsById(){
            if(!this.currentSelection){
                return null;
            }
            return this.currentSelection.options.map(item=>{
                return item.id;
            });
        }
    },
    methods:{
        removeSelection(data){
            this.selections = this.selections.filter((item)=>{
                return item.id !== data.id;
            });
        },
        updateSelectionArray(data){

            if(data.hasOwnProperty('isUpdating')){
                const selection = this.selections.find((item)=>{
                    return item.id === data.id;
                });

                selection.title = data.title;

                return;
            }

            if(data.hasOwnProperty('isDeleting')){
                this.selections = this.selections.filter((item)=>{
                    return item.id !== data.id;
                });

                return;
            }

            this.selections.push(data);
        },
        openAddOptionModal(selection){
            this.showOptionListModal = true;
            this.currentSelection = selection;
        },
        addOption(option){
            this.currentSelection.options.push({
                option,
                quantity: parseInt(this.quantity),
            });
            this.showOptionListModal = false;
            this.currentSelection = null;
        },
        increaseQuantityForOption(selection, option){
            const foundOption = selection.options.findIndex((item)=>{
                return item.option.id === option.option.id
            });



            selection.options[foundOption].quantity += 1;
        },
        decreaseQuantityForOption(selection, option){
            const foundOptionIndex = selection.options.findIndex((item)=>{
                return item.option.id === option.option.id
            });

            if(selection.options[foundOptionIndex].quantity > 0) selection.options[foundOptionIndex].quantity -= 1;

        },
        removeOption(selection, option){
            selection.options = selection.options.filter(item =>{
                return item.option !== option;
            })
        },
        showEditSelectionModal(selection){
            this.currentSelection = selection;
            this.showEditModal = true;
        },
        showDeleteSelectionModal(selection){
            this.currentSelection = selection;
            this.showDeleteModal = true;
        },
        selectionCreated(data){
            this.showCreateModal = false;
            this.selections.push(data);
        },
        selectionUpdated(data){
            this.showEditModal = false;
            this.currentSelection.title = data.title;
            this.currentSelection = null;
        },
        deleteSelection(selection){
            this.selections = this.selections.filter((item)=>{
                return item.id !== selection.id
            });
        },
        storeDetailsAndContinue(){
            if(!this.validateProduct) return;

            this.$store.dispatch('productless/setTitle', this.title);
            this.$store.dispatch('productless/setQuantity', this.quantity);
            this.$store.dispatch('productless/setPricePerUnit', this.price_per_unit);
            this.$store.dispatch('productless/setSelections', this.selections);
            this.$store.dispatch('productless/completedProduct');

            this.$router.push({
                name: 'make-productless-order.order',
            })
        }
    },
    created() {

        if(this.$store.getters['productless/completedPayment']){
            this.$store.dispatch('productless/resetOrder');
        }

        if(this.$store.getters['productless/order'].details.title){
            this.title = this.$store.getters['productless/order'].details.title;
        }

        if(this.$store.getters['productless/order'].details.quantity){
            this.quantity = this.$store.getters['productless/order'].details.quantity;
        }

        if(this.$store.getters['productless/order'].details.selections){
            this.selections = this.$store.getters['productless/order'].details.selections;
        }

        if(this.$store.getters['productless/order'].details.price_per_unit){
            this.price_per_unit = this.$store.getters['productless/order'].details.price_per_unit;
        }

    }
}
</script>

<style scoped>

</style>
